import * as React from "react";
import RestaurantHeader from "../restaurant/RestaurantHeader";
import {useSelector} from "react-redux";
import {useEffect} from "react";
import {LocalizerHelper} from "../../helpers/localizerHelper";
import {useNavigate, useParams} from "react-router";
import {ORDER_APPROVEMENT_REQUESTS_STATUS} from "../../constants/data";
import {Button} from "@material-ui/core";
import Screen from '../screen';
import './index.scss';
import { RootState } from "../../store";

const _defaultMaxWaitingTime = 90 * 1000;
let timeElapsed = 0;

const WaitingOrderApprovement = () => {
    const navigate = useNavigate();

    const { 
        link_alias: link_alias,
        restaurant: restaurantId, 
        menu: menuId, 
        dits: sessionId,
        requestId: requestId
    } = useParams<{ restaurant: string; menu: string, link_alias: string, dits: string, requestId: string}>();

    const restaurant = useSelector((state: RootState) => state.restaurant.restaurant);
    const request = useSelector((state: RootState) => state.approvementRequest.approvement);
    const bills = useSelector((state: RootState) => state.bill.bills);
    const mustPayFirst = useSelector((state: RootState) => state.session.session?.must_pay_first);

    const lastLinkAlias = (window.localStorage) ? (window.localStorage.getItem('chuzeat_last_alias_link') ?? '' ) : '';

    const maxWaitingTime = (restaurant?.max_order_approvement_waiting_time ?? _defaultMaxWaitingTime) + (10*1000);
    const msgWatingForApproval = LocalizerHelper.localized('loading_msg_wait_for_approval') ?? "";
    let countDownValue = (maxWaitingTime)/1000;
    let timeElapsedInterval:any = null;

    const [loading, setLoading] = React.useState(true);
    const [waitForBill, setWaitForBill] = React.useState(false);
    const [orderRejected, setOrderRejected] = React.useState(false);
    const [countdown,setCountDown] = React.useState((maxWaitingTime)/1000);

    useEffect(() => {
        timeElapsedInterval = setInterval(() => {
            timeElapsed += 1000;
            countDownValue = countDownValue - 1;
            countDownValue = (countDownValue < 0) ? 0 : countDownValue;
            console.log(countDownValue);
            setCountDown(countDownValue);
        }, 1000);
        return () => {
            if(timeElapsedInterval){
                clearInterval(timeElapsedInterval);
                timeElapsedInterval = null;
            }
        }
    }, []);

    useEffect(() => {
        if (!!request) {
            const isOrderApproved = request.status === ORDER_APPROVEMENT_REQUESTS_STATUS.approved;
            const isOrderRejected = request.status === ORDER_APPROVEMENT_REQUESTS_STATUS.rejected;
            if (isOrderApproved || isOrderRejected) {
                if (!!timeElapsedInterval) {
                    clearInterval(timeElapsedInterval);
                }
                if (isOrderApproved) {
                    setWaitForBill(true);
                    return;
                } else if (isOrderRejected) {
                    setLoading(false);
                    setOrderRejected(isOrderRejected);
                }
            }
        }
    }, [request]);

    useEffect(() => {
        if (bills.length > 0 && waitForBill) {
            setLoading(false);
            setWaitForBill(false);
            if (mustPayFirst) {
                const alias = link_alias ?? lastLinkAlias;
                navigate(`/menu/${alias}/payment/${restaurantId}/${sessionId}/${menuId}`);
            } else {
                const alias = link_alias ?? lastLinkAlias;
                navigate(`/menu/${alias}/thanks/${restaurantId}/${sessionId}/${menuId}`);
            }
        }
    }, [bills, waitForBill, mustPayFirst]);

    const newOrder = () => {
        console.log("@@@@ newOrder");
        const alias = link_alias ?? lastLinkAlias;
        const url = `/menu/${alias}`
        window.location.href = url
    }

    return (<Screen className="screen screen-wait-for-approvement">
       <RestaurantHeader showBack={false} className='full-width block'/>
        <div className="container waiting-order-approvement-main-container">
            {(orderRejected) ?
                <div className="row">
                    <div className="col-12">
                        <div className="container-loader">
                            <div className="container">
                                    <div className="container-img-loader">
                                        <div className="bkg-img"></div>
                                        <img className="loader-img"src="/assets/msg_not_order_approval.gif"/>
                                    </div>
                            </div>
                        </div>
                    </div>    
                    <div className="col-12 error_message">
                        <p className="user_questions">{LocalizerHelper.localized('order_not_approved_by_restaurant_owner')}</p>
                    </div>
                    <div className="row container-buttons-action">
                        <div className="col-md-12">
                            <Button className='accent-button full-width button button' onClick={() => newOrder()}>
                                {LocalizerHelper.localized('new_order')}
                            </Button>
                        </div>
                    </div>
                </div>
                :
              <div className="row">
                <div className="col-12">
                        <div className="container-loader">
                            <div className="container">
                                    <p className="message" dangerouslySetInnerHTML={{__html: msgWatingForApproval.replace('%@', countdown.toString())}}/>
                                    <div className="container-img-loader">
                                        <div className="bkg-img"></div>
                                        <img className="loader-img"src="/assets/loading_wait_approval_restaurant.gif"/>
                                    </div>
                            </div>
                        </div>
                </div>
              </div>
            }
        </div>
    </Screen>);
}

export default WaitingOrderApprovement;
